module.exports = __webpack_public_path__ + "static/media/dictationBackground.c0f3ecd0.jpg";